<template>
<div>
<div class="row myheader">
<div class="col-2">
<transition name="fade">
  	<mt-button class="fa fa-angle-left back" @click="doback()"></mt-button>
 </transition> 	
 </div>

 <div class="col-6 title">
  <router-link to="/" v-show="mydata.nav=='/'">
  	<img src="../../images/logo.png" alt="第一健康" class="logo">
  </router-link> 
 </div>

 <div class="col-2 reg" @click="toreg">
   注册
 </div>
</div>

<div class="container bgray">

<div class="row">
	<hos @select="hi" :hos="fy"></hos>
</div>


<div class="form">
<div class="row">
		<div class="col-3 left">用户名</div>
		<div class="col-7">
			<mt-field placeholder="请输入用户名" v-model="username"></mt-field>
		</div>
</div>	

<div class="row">
		<div class="col-3 left">密&nbsp;&nbsp;码</div>
		<div class="col-7">
			<mt-field placeholder="请输入密码" type="password" v-model="password"></mt-field>
		</div>
</div>

<div class="row" v-show="show_code_row">	
	<div class="col-3 left">验证码</div>
	<div class="col-4 nopadding">
		 <mt-field placeholder="请输入验证码" v-model="code" @keydown.native.enter="sub" @input="check"></mt-field>
	</div>
	<div class="col-3 nopadding codediv">
		 <img :src="mydata.api+'Code/code/tk/'+tk" class="code" alt="验证码" @click="change($event)">
		 <span class="success" v-show="success"><i class="fa fa-check"></i></span>
	</div>
</div>

</div> <!-- form -->
<div class="row">
    <div class="col-1" v-if="mydata.width>359"></div>
    <div :class="{'col-6':mydata.width>359,'col-7':mydata.width<=359}">
        <mt-switch v-model="remember"> 两周内记住登录密码</mt-switch>
    </div>
    <div class="col-3 hl">
        <router-link to="/forget"><i class="fa fa-question-circle-o"></i> 忘记密码</router-link>
    </div>
</div>	

<div class="row pdd" v-if="!is_wx">
	<mt-button type="primary" size="large" @click="sub">登 录</mt-button>
</div>

<div class="row pd" v-if="is_wx">
    <div class="col-5">
        <mt-button type="primary" size="large" @click="sub">登 录</mt-button>
    </div>
    <div class="col-5">
        <mt-button type="default" size="large" class="wxlogin" @click="wxlogin">微信登录</mt-button>
    </div>
</div>

</div>


</div>	
</template>

<style scoped>

.bgray{background:rgb(251,251,251);}
.container{padding-top: 3rem;}
.gray{color:rgb(117,117,117);}
.hl{height:2.1rem;line-height: 2.1rem;}
.pdd,.pd .col-5{padding:1rem;}
.bb{border-bottom: 1px solid #ddd;}
.myheader .reg{font-size: 1.2rem;line-height: 2.8rem;}
.wxlogin{border:1px solid #26a2ff;color:#26a2ff;}
</style>

<script>
import hos from "../../lib/hos.vue"

export default{
	components:{hos},
	data(){
		return {
			mydata:mydata,
			username:"",
			password:"",
			code:"",
			fy:'请选择体检分院',
			remember:false,
			api:api,
			tk:"",
			success:false,
			is_wx:false,//不使用微信登录
            show_code_row:false,
			// is_wx:fun.is_weixin(),
		}
	},
	created:function(){
		this.mydata.header=false;
		this.tk=new Date().getTime();
        this.login();//微信登录跳转后自动登录
        var hos=localStorage.getItem("hos");
        if(hos && hos.indexOf('expire')!=-1){
            this.username=fun.local("user")?fun.local("user"):"";
            this.fy=fun.local("hos")&&fun.local("hos").length==2?fun.local("hos"):"请选择体检分院";
        }
	},
	methods:{
		hi:function(e){
			this.fy=e;
		},
		doback(){
          this.$router.push("/");
		},
		toreg:function(){
           this.$router.push("/reg");
		},
		change:function(e){
			this.tk=new Date().getTime();
            this.success=false;
            // console.log("e",e)
            // e.preventDefault();
            // return false;//阻止QQ浏览器中点击图片后自动跳转，无效
		},
		wxlogin:function(){
		   var url="http://www.dyjk.cn/Wxweb/Index/mobile_login";
		   location.href=url;
		},
		login:function(){
		   var token=fun.cookie("tk");
		   var expire=fun.cookie("expire");
           if(token&&expire&&expire*100<new Date().getTime()){
			    fun.local("token",token);
          		fun.local("name",fun.cookie("name"));
          		fun.local("avatar",fun.cookie("avatar"));
                fun.local("hos",fun.cookie("hos"));
				fun.local("expire",expire*1000);
				this.$router.push("/user/index");
		   }
		},
		check:function(){
           var data={
           	tk:this.tk,
           	code:this.code,
           }
           var _this=this;
           fun.post(mydata.api+"Code/mycheck",data,function(d){
           	console.log(d)
           	_this.success=d.status==1?true:false;
           },true)
		},
        sub:function(){
        	var data={
        		user:this.username,
        		psd:this.password,
        		hos:this.fy,
        		rem:this.remember,
        		tk:this.tk,
        		code:this.code,
        	}
          if(data.hos.trim()==""){this.$toast("请选择体检分院");return;}
          if(data.user.trim()==""){this.$toast("用户名不能为空");return;}
          if(data.psd.trim()==""){this.$toast("密码不能为空");return;}
          var _this=this;
          fun.post(mydata.api+'Login/login',data,function(d){
          	console.log("login succ",d);
          	if(d.status==1){
          		fun.local("token",d.info.token);
          		fun.local("name",d.info.name);
          		fun.local("avatar",picurl+d.info.avatar);
                fun.local("hos",data.hos);
                fun.local("user",data.user);
                fun.local("expire",d.info.expire*1000);
                var from_url=fun.cookie("wj_goods_url");
                if(from_url){
                    location.href=from_url;
                }else{
                    _this.$router.push("/user/index");
                }
          	}else{
                if(d.info=='请输入验证码'){
                    _this.show_code_row=true;
                }else if(d.info!="验证码错误"){
                    _this.change();
                }
          		_this.$toast(d.info);
          	}
          })
        }

	}
}	
</script>


// WEBPACK FOOTER //
// src/components/login/index.vue